import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Container,
  makeStyles,
  Paper,
  Slider,
  Tooltip,
  Typography,
  Chip,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import t from "../common/localization";
import PositionsMap from "../googlemap/PositionsMap";
import DirectionMarkerOnReplay from "../googlemap/DirectionMarkerOnReplay";
import StopsMap from "../googlemap/StopsMap";
import { formatPosition } from "../common/formatter";
import ReplayFilter from "./ReplayFilter";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import PauseIcon from "@material-ui/icons/Pause";
import RestoreIcon from "@material-ui/icons/Restore";
import { Polyline, Marker } from "@react-google-maps/api";
import { showLoaderStateActions } from "./../store";
import { useDispatch, useSelector } from "react-redux";
import ClearIcon from "@material-ui/icons/Clear";
import Fab from "@material-ui/core/Fab";
import Grid from "@material-ui/core/Grid";
import DriveEtaIcon from "@material-ui/icons/DriveEta";
import { formatDate, formatDistance } from "../common/formatter";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "row",
  },
  controlPanel: {
    position: "absolute",
    bottom: theme.spacing(4),
    left: "50%",
    transform: "translateX(-50%)",
    width: "90%",
    opacity: "0.8",
  },
  button: {
    border: 0,
    borderRadius: 18,
    boxShadow: "0 3px 5px 2px rgba(33, 203, 243, .3)",
    height: "30px",
    width: "40px",
    color: "white",
    margin: "3px",
    marginRight: "15px",

    // padding: '0 20px',
  },
  controlContent: {
    marginBottom: theme.spacing(1),
    width: "91%",
  },
  configForm: {
    display: "flex",
    flexDirection: "column",
  },
  speedSlider: {
    display: "flexEnd",
    flexDirection: "row",
    marginLeft: "10px",
    marginBottom: "-10px",
    width: 90,
  },
  speedSlider1: {
    display: "flexEnd",
    flexDirection: "row",
    marginRight: "15px",
    marginLeft: "15px",
    marginBottom: "-10px",
    width: 400,
  },
}));

const polyLineOptions = {
  strokeColor: "#06571c",
  strokeOpacity: 1,
  strokeWeight: 3,
  fillColor: "#06571c",
  fillOpacity: 9,
  clickable: false,
  draggable: false,
  editable: false,
  visible: true,
  // paths: latLngCoordinates,
  zIndex: 1,
};

let sliderInterval = null;
const TimeLabel = ({ children, open, value }) => {
  return (
    <Tooltip open={open} enterTouchDelay={0} placement="top" title={value}>
      {children}
    </Tooltip>
  );
};

const ReplayPage = ({ reSetMap, mapRef }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const selectedDevice = useSelector((state) => {
    if (state.devices.selectedId) {
      const id = state.devices.selectedId;
      return state.devices.items[id];
    }
    return {};
  });

  const [expanded, setExpanded] = useState(true);
  const [positions, setPositions] = useState([]);
  const [stopDataList, setStopDataList] = useState([]);
  const [firstPosition, setFirstPosition] = useState([]);
  const [lastPosition, setLastPosition] = useState([]);
  const [totalDistanceTravelled, setTotalDistanceTravelled] = useState(0);
  const [index, setIndex] = useState(0);
  const [speed, setSpeed] = useState(1800);
  const [polyLineData, setPolyLineData] = useState([]);
  const [playButton, setPlayButton] = useState(true);
  const [initialLoad, setInitialLoad] = useState(true);
  const [polyLineChunk, setPolyLineChunk] = useState([]);
  const [distanceVal, setDistanceVal] = useState([]);
  const [dateRange, setDateRange] = useState({
    to: "",
    from: "",
  });

  var [bounds, setBounds] = useState();
  const speedLimit = selectedDevice.attributes?.speedLimit || 500;

  useEffect(() => {
    if (!initialLoad) {
      playSlider();
    }
  }, [speed]);

  const handleSubmit = async (deviceId, from, to, _, headers) => {
    dispatch(showLoaderStateActions.addState(true));
    setDateRange({ from, to });

    const query = new URLSearchParams({ deviceId, from, to });

    const response = await fetch(
      `/api/reports/routeWithStops?${query.toString()}`,
      {
        headers,
      }
    );
    dispatch(showLoaderStateActions.addState(false));

    if (response.ok) {
      setIndex(0);
      const routeDetails = await response.json();
      if (
        routeDetails.onlyMovingPositionList &&
        routeDetails.onlyMovingPositionList.length
      ) {
        const polyLineData = routeDetails.onlyMovingPositionList.map(
          (item) => ({ lat: item.latitude, lng: item.longitude })
        );
        const newdata = [];
        let newItem = {};
        routeDetails.onlyMovingPositionList.forEach((element, idx, arrlist) => {
          const color = element.speed >= speedLimit ? "red" : "green";
          const elem = { lat: element.latitude, lng: element.longitude };
          if (newItem[color]) {
            newItem[color].push(elem);
          } else {
            let lastItem = null;
            const colorCode = Object.keys(newItem);
            if (colorCode.length > 0) {
              newdata.push(newItem);
              lastItem =
                newItem[colorCode[0]][newItem[colorCode[0]].length - 1];
            }

            newItem = { [color]: lastItem ? [lastItem] : [] };
            newItem[color].push(elem);
          }
          if (idx === arrlist.length - 1) {
            newdata.push(newItem);
          }
        });

        setPolyLineChunk(newdata);

        const stopDataList =
          routeDetails.stopDataList && routeDetails.stopDataList;
        setStopDataList(stopDataList);

        setPolyLineData(polyLineData);

        bounds = new window.google.maps.LatLngBounds();
        for (var i = 0; i < polyLineData.length; i++) {
          bounds.extend(polyLineData[i]);
        }
        polyLineOptions.bounds = bounds;
        mapRef.fitBounds(bounds);
        // window.googlemap.fitBounds(bounds);
      }
      setPositions(routeDetails.onlyMovingPositionList);
      // setStopDataList(routeDetails.stopDataList);
      setFirstPosition(routeDetails.firstPosition);
      setLastPosition(routeDetails.lastPosition);
      setTotalDistanceTravelled(routeDetails.totalDistanceTravelled);
      setExpanded(false);
    }
  };
  const playSlider = () => {
    setPlayButton(false);
    let i = index;
    sliderInterval = setInterval(() => {
      if (i >= positions.length) {
        clearInterval(sliderInterval);
        return;
      }
      i = i + 1;
      setIndex(i);
    }, speed);
  };
  const stopSlider = () => {
    setPlayButton(true);

    sliderInterval && clearInterval(sliderInterval);
    sliderInterval = null;
  };

  const resetSlider = () => {
    stopSlider();
    setIndex(0);
  };
  const valueText = (value) => {
    return `${value}x`;
  };
  const handleSliderChange = (event, value) => {
    stopSlider();
    setInitialLoad(false);
    setSpeed(1800 / value);
  };

  const markeronPlayBack = positions.filter((item, index) => {
    return index % 10 === 0;
  });

  return (
    <div className={classes.root}>
      {polyLineData.length && positions.length && (
        <>
          {polyLineChunk.map((poly) => {
            const key = Object.keys(poly);
            if (key[0]) {
              return (
                <Polyline
                  onLoad={() => {}}
                  path={poly[key[0]]}
                  options={{
                    ...polyLineOptions,
                    strokeColor: key[0],
                    fillColor: key[0],
                  }}
                  bounds={bounds}
                />
              );
            }
          })}
          {positions[index] && <PositionsMap positions={[positions[index]]} />}
          <DirectionMarkerOnReplay scaleSize={2} positions={markeronPlayBack} />
          {stopDataList && <StopsMap stopDataList={stopDataList || []} />}
        </>
      )}
      <Container
        maxWidth="md"
        className={classes.controlPanel}
        id="replay-container"
      >
        {!!positions.length && (
          <>
            <Paper className={classes.controlContent} elevation={4}>
              <Container>
                <Slider
                  className={classes.speedSlider1}
                  max={positions.length - 1}
                  step={null}
                  marks={positions.map((_, index) => ({ value: index }))}
                  value={index}
                  onChange={(_, index) => {
                    setIndex(index);
                  }}
                  valueLabelDisplay="auto"
                  valueLabelFormat={(i) =>
                    i < positions.length
                      ? formatPosition(positions[i], "fixTime")
                      : ""
                  }
                  ValueLabelComponent={TimeLabel}
                />

                {playButton ? (
                  <Button
                    color="primary"
                    onClick={playSlider}
                    className={classes.button}
                  >
                    <PlayArrowIcon color="white" />{" "}
                  </Button>
                ) : (
                  <Button
                    color="primary"
                    onClick={stopSlider}
                    className={classes.button}
                  >
                    <PauseIcon color="white" />{" "}
                  </Button>
                )}

                <Button
                  color="primary"
                  onClick={resetSlider}
                  className={classes.button}
                >
                  <RestoreIcon color="white" />
                </Button>
              </Container>

              <Container>
                <Grid container spacing={1}>
                  <Grid item xs={2.5}>
                    <Slider
                      className={classes.speedSlider}
                      defaultValue={1}
                      getAriaValueText={valueText}
                      aria-labelledby="discrete-slider-small-steps"
                      step={1}
                      marks
                      min={1}
                      max={5}
                      aria-labelledby="discrete-slider-always"
                      valueLabelDisplay="auto"
                      onChangeCommitted={handleSliderChange}
                    />
                  </Grid>
                  <Grid item xs={1.5}>
                    <Chip
                      size="small"
                      label={selectedDevice.name}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={1.5}>
                    <Chip
                      label={formatDistance(totalDistanceTravelled)}
                      variant="outlined"
                      icon={<DriveEtaIcon />}
                      size="small"
                      style={{
                        backgroundColor: "#EFEBFC",
                        color: "#623DE6",
                        borderRadius: 3,
                      }}
                    />
                  </Grid>
                  <Grid item xs={3.2}>
                    <Chip
                      size="small"
                      label={`From: ${formatDate(
                        dateRange.from,
                        "MMM D, hh:mm A"
                      )}`}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={3.2}>
                    <Chip
                      size="small"
                      label={`To: ${formatDate(
                        dateRange.to,
                        "MMM D, hh:mm A"
                      )}`}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
              </Container>
            </Paper>
          </>
        )}
        <div>
          <Grid container spacing={3}>
            <Grid item xs={10}>
              <div>
                <Accordion
                  expanded={expanded}
                  onChange={() => setExpanded(!expanded)}
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography align="center">
                      {t("reportConfigure")}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.configForm}>
                    <ReplayFilter
                      handleSubmit={handleSubmit}
                      distanceVal={distanceVal}
                      showOnly
                    />
                  </AccordionDetails>
                </Accordion>
              </div>
            </Grid>
            <Grid item xs={2}>
              <div>
                <Fab
                  size="small"
                  color="primary"
                  aria-label="reset"
                  onClick={reSetMap}
                >
                  <ClearIcon />
                </Fab>
              </div>
            </Grid>
          </Grid>
        </div>
      </Container>
    </div>
  );
};

export default ReplayPage;
